import Axios from 'axios'
import { API_HOST } from './APointAPI.js'
import store from "../store/index";
// import { router } from '@/router'
// import { indexedDBStorage } from '@/services/indexedDb.service.js'
// const API_HOST = ''
// ההרשאות CORS עובדות על loclhost:8080-8090
// 127.0.0.1:5050-5060

const axios = Axios.create({
  withCredentials: true,
})

const PREFIX = '/BuildApp/'
// const axios = Axios.create()

export const httpService = {
  get(endpoint, data, withPrefix) {
    return ajax(endpoint, 'GET', data, withPrefix)
  },
  post(endpoint, data, withPrefix, config) {
    return ajax(endpoint, 'POST', data, withPrefix, config)
  },
  put(endpoint, data, withPrefix) {
    return ajax(endpoint, 'PUT', data, withPrefix)
  },
  delete(endpoint, data, withPrefix) {
    return ajax(endpoint, 'DELETE', data, withPrefix)
  },
}

async function ajax(
  endpoint,
  method = 'GET',
  data = null,
  withPrefix = true,
  config = {}
) {
  try {
    const headers = {}
    const sessionToken = store.state.api.sessionToken
    if (sessionToken) {
      headers.Authorization = sessionToken
    }
    console.log(`${API_HOST}${withPrefix ? PREFIX : ''}${endpoint}`)
    // const sessionToken = authService.getSessionToken()
    const res = await axios({
      url: `${API_HOST}${withPrefix ? PREFIX : ''}${endpoint}`,
      method,
      data,
      params: method === 'GET' ? data : null,
      headers,
      // headers: {
      //   Authorization: sessionToken
      // }
      responseType: config.responseType || 'json', // Ensure responseType is handled
      ...config,
    })

    return res.data
  } catch (err) {
    console.log(
      `Had Issues ${method}ing to the backend, endpoint: ${endpoint}, with data:`,
      data
    )
    console.dir(err)

    throw err
  }
}
